var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBw10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.528,
    height: 47,
    viewBox: "0 0 41.528 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1734",
    "data-name": "Group 1734",
    transform: "translate(-477.683 -328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "reload",
    transform: "translate(477.683 328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1730",
    "data-name": "Group 1730",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4774",
    "data-name": "Path 4774",
    d: "M71.333,26.236a20.764,20.764,0,0,1-41.528,0,1.232,1.232,0,0,1,2.463,0,18.3,18.3,0,1,0,18.3-18.3H48.432l3.055,3.42A1.232,1.232,0,1,1,49.651,13L45.283,8.107a2.106,2.106,0,0,1,0-2.808L49.651.411a1.232,1.232,0,1,1,1.837,1.641l-3.055,3.42h2.137A20.788,20.788,0,0,1,71.333,26.236Z",
    transform: "translate(-29.805)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "_10",
    "data-name": 10,
    transform: "translate(498.372 360.189)",
    fill: "#fafafa",
    fontSize: 16,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8,
    y: 0
  }, "10")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBw10);
export default __webpack_public_path__ + "static/media/bw10.2497f1a161d2722525758c59564bcdae.svg";
export { ForwardRef as ReactComponent };